var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "promoBadge d-flex justify-content-center align-items-center",
    },
    [
      _vm.chevrons
        ? _c("i", { staticClass: "icon-eatselfapp_chevron flipH" })
        : _vm._e(),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.labelPromotion))]),
      _vm._v(" "),
      _vm.chevrons
        ? _c("i", { staticClass: "icon-eatselfapp_chevron" })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }